import {Input} from "@angular/core";
import {DetailConfigurationField} from "../../../models/detail-configuration-field";

export class Field
{


    /**
     * Attributes
     */
    STR_dependent_fields = "";
    @Input()
    OBJ_field_config: DetailConfigurationField;

    @Input()
    OBJ_data;


    /**
     * Function > isInvalid
     * @return {boolean}
     */
    isInvalid(): boolean
    {
        return false;
    } // end function isInvalid


    /**
     * Function > getLabelName
     * @return {string}
     */
    getLabelName(): string
    {
        return (this.OBJ_field_config.label||this.OBJ_field_config.name.toLocaleLowerCase());
    } // end Function getLabelName


    /**
     * Function > getHint
     * @return {string}
     */
    getHint(): string
    {

        let STR_hint = "";
        if (this.OBJ_field_config.hint)
        {
            // Hint ist direkt ueber Konfig mitgegeben
            if(typeof(this.OBJ_field_config.hint) == "string")
            {
                STR_hint = this.OBJ_field_config.hint;
            }
            else
            {
                // erzeuge hint aus namen oder label
                STR_hint = ((this.OBJ_field_config.label||this.OBJ_field_config.name) + "_hint").toLocaleLowerCase();
            } // end if

        } // end if
        return STR_hint;

    } // end Function getHint


    /**
     * Function > getDependentFields
     * @param OBJ_translate_service
     */
    getDependentFields(OBJ_translate_service)
    {

        // Sammle alle Felder, die von diesem Feld abhaengen, um eine Warnung anzeigen zu koennen
        if(this.OBJ_field_config.dependent_fields)
        {
            for (let _i = 0; _i < this.OBJ_field_config.dependent_fields.length; _i++) {

                if(_i > 0)
                {
                    this.STR_dependent_fields += ", ";
                } // end if

                this.STR_dependent_fields += OBJ_translate_service.instant(this.OBJ_field_config.dependent_fields[_i]);

            } // end for

        } // end if

    } // end function getDependentFields

    
    /**
     * Function > isRequired
     */
    isRequired()
    {
        
        if (this.OBJ_field_config.validators)
        {
            for (let OBJ_validator of this.OBJ_field_config.validators) {

                if (OBJ_validator.type === 'required')
                {
                    return true;
                } // end if

            } // end for

        } // end if

        return false;
        
    } // end function isRequired
	
	
	/**
	 * Function > setValue
	 * @param {any} MIX_value
	 * @return void
	 */
	setValue(MIX_value: any): void
	{
        this.OBJ_field_config.value = MIX_value;
    } // end function setValue


} // end class Field